import React from 'react';
import './styles.css';
import NavBar from './NavBar';
import { GooglePlayButton, AppStoreButton } from "react-mobile-app-button";
import screenshot1 from './../assets/screenshot-1.png';

const Download = () => {
  return (
    <>
    {NavBar()}
    <div className="download-page-wrapper">
      <div className="download-hero-section">
        <div className="download-text-container">
          <h1 className="download-title">Ready to make real connections?</h1>
          <p className="download-subtitle">
            Whether you're new in town or just looking to expand your social circle, Pool Party Social Club is the human way to meet people.
            Jump in and see who's waiting in your city.
          </p>

          <div className="download-buttons-container">
            <GooglePlayButton
              url="https://play.google.com/store/apps/details?id=com.consolelog.poolparty"
              theme="dark"
              className="custom-google-play-button"
            />
            {/* iOS coming soon
            <AppStoreButton
              url="#"
              theme="dark"
              className="custom-apple-button"
            />
            */}
          </div>

          <p className="download-footer-text">Available on Android. iOS coming soon.</p>
        </div>

        <div className="download-image-container">
          <img
            src={screenshot1}
            alt="Pool Party Social Club App Screenshot"
            className="download-screenshot-image"
          />
        </div>
      </div>

      {/* SEO Paragraph Section */}
      <div className="seo-text-section">
        <h2>The Future of Social Connection Starts Here</h2>
        <p>
          Pool Party Social Club isn't just another social app—it's a revolution in real-time connection. Our platform lets you meet people instantly through live video chats, helping you skip the small talk and get to know someone face-to-face. Whether you're looking to make new friends, find people with shared interests, or just expand your social network, Pool Party provides a more authentic, human experience.
        </p>
        <p>
          Forget ghosting and endless messaging—Pool Party is about presence, spontaneity, and genuine connection. Our unique features like "Splashing," live local Pools, and face-to-face video help you discover nearby people in a whole new way. If you've been searching for the best way to meet people online and actually have real conversations, your search ends here. Download Pool Party Social Club today and meet someone worth knowing.
        </p>
      </div>
    </div>
     </>
  );
};

export default Download;
